module.exports = __webpack_public_path__ + "img/1538671056.a802c14f.jpg";